import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 z-[60] h-[2px] w-full origin-left bg-cyan-accent shadow-[0_0_12px_rgba(0,240,255,0.7)]"
      data-testid="scroll-progress"
    />
  );
}
